import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { Row, Col, Container } from 'react-bootstrap'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import MocktestAnalysisSection from '../components/mocktest_analysis/MocktestAnalysisSection'
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
  } from "react-device-detect";


const FETCH_MOCKTESTS = gql`
query($institution_id :Int!){
    getRizeeMockTests(institution_id: $institution_id){
        id
        exam_name
        start_time
        end_time
        exam_type
      }
  }
`;

const FETCH_GLOBALS = gql`
query($institution_id :Int!){
    globals(institution_id:$institution_id){
        exams{
            id
            exam
          }
          testTypes{
            id
            type
          }
    }
}
`

class MocktestAnalysis extends Component {
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {
        console.log("this.props.globalsthis.props.globals",this.props.globals1)
        if (Cookies.get("token") == undefined) this.props.history.push("/login");

        const getRizeeMockTests = this.props.getRizeeMockTests
        const loading1 = getRizeeMockTests.loading;
        const error1 = getRizeeMockTests.error

        const globals=this.props.globals1;
        const loading2=globals.loading;
        const error2=globals.error;


        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                    <SideNavbar onClick={() => this.menuToggler()} />
                </div>
                <div className="content-page">
                    <NavbarOne onClick={() => this.menuToggler()} />
                    <div className="overlay" onClick={() => this.menuToggler()} />
                    <div className="main-content">
                        {
                            loading1 || loading2 ?
                                (
                                    <Container><Row className="my-3">
                                        <Col>
                                            <div class="spinner-border text-primary text-center loading-img-center"></div>
                                        </Col>
                                    </Row></Container>
                                )
                                :
                                (
                                    
                                    <MocktestAnalysisSection
                                        getRizeeMockTests={getRizeeMockTests.getRizeeMockTests}
                                        globals={globals.globals}
                                    />
                                )
                        }
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(
    compose(
        graphql(FETCH_MOCKTESTS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    }
                }), name: "getRizeeMockTests"
            }),
            graphql(FETCH_GLOBALS,{
                options:props=>({
                    variables:{
                        institution_id:parseInt(Cookies.get("institutionid"))
                    }
                   
                }), name:"globals1"
            })

    )
        (MocktestAnalysis));